import administrationDashboardMoreEvents from "~/store/graphql/queries/administrationDashboardMoreEvents.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminstrationMoreEvents = async function (
  { commit },
  { params, req, res }
) {
  const data = await runGraphQLQuery(
    administrationDashboardMoreEvents,
    params,
    this.$axios,
    req,
    res
  );

  commit("SET_ADMINISTRATION_MORE_EVENTS", data);

  return Promise.resolve(data);
};

export default loadAdminstrationMoreEvents;
